//Local Link
export const link = process.env.REACT_APP_BACKEND_URL
export const socketLink = process.env.REACT_APP_WEBSOCKET_LINK